import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Home from './views/Home.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

// 导入 Home.vue 组件（确保 Home.vue 也在 src 根目录，若在子文件夹需调整路径，如 ./views/Home.vue）

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Home))
}
}

})